<!-- used to trick browsers into autofilling these inputs instead of the actual username and password inputs -->
<input
  style="display: none"
  type="text"
  name="username"
  autocomplete="username"
/>
<input
  style="display: none"
  type="password"
  name="password"
  autocomplete="new-password"
/>
<ng-container *ngIf="integrationInput$ | async"></ng-container>
<ng-container [formGroup]="integrationForm">
  <h5 class="wizard-heading-1">{{ "integration_info" | translation }}</h5>
  <div class="wizard-integration-create-form-fields-container">
    <nb-form-field>
      <label>{{ "integration_url" | translation }}</label>
      <ng-container
        *ngIf="
          integrationForm?.controls?.url?.invalid &&
          (integrationForm?.controls?.url?.dirty ||
            integrationForm?.controls?.url?.touched)
        "
      >
      </ng-container>
      <input
        [placeholder]="'URL' | translation"
        style="max-width: 100%"
        formControlName="url"
        nbInput
        [ngClass]="
          integrationForm?.controls?.url?.pristine
            ? ''
            : integrationForm?.controls?.url?.valid
            ? 'input-valid'
            : 'input-invalid'
        "
      />
      <div class="wizard-integration-create-form-field-label-error-wrapper">
        <span
          class="wizard-integration-create-form-field-label-error"
          *ngIf="
            integrationForm?.controls?.url?.dirty &&
            integrationForm?.controls?.url?.errors?.required
          "
        >
          <i class="fa-solid fa-triangle-exclamation"></i>
          {{ "required" | translation }}
        </span>
        <span
          class="wizard-integration-create-form-field-label-error"
          *ngIf="
            integrationForm?.controls?.url?.dirty &&
            integrationForm?.controls?.url?.errors?.pattern &&
            !integrationForm?.controls?.url?.errors?.required
          "
        >
          <i class="fa-solid fa-triangle-exclamation"></i>

          {{ "must_be_a_valid_url" | translation }}
        </span>
      </div>
    </nb-form-field>
    <nb-form-field>
      <label>{{ "friendly_name" | translation }}</label>
      <input
        [placeholder]="'friendly_name' | translation"
        style="max-width: 100%"
        formControlName="friendlyName"
        nbInput
        [ngClass]="
          integrationForm?.controls?.friendlyName.pristine
            ? ''
            : integrationForm?.controls?.friendlyName.valid
            ? 'input-valid'
            : 'input-invalid'
        "
      />
      <div class="wizard-integration-create-form-field-label-error-wrapper">
        <span
          class="wizard-integration-create-form-field-label-error"
          *ngIf="
            integrationForm?.controls?.friendlyName?.dirty &&
            integrationForm?.controls?.friendlyName?.errors?.required
          "
        >
          <i class="fa-solid fa-triangle-exclamation"></i>

          {{ "required" | translation }}
        </span>
      </div>
    </nb-form-field>
  </div>

  <div class="wizard-integration-create-form-fields-container">
    <nb-form-field autocomplete="new-util-username">
      <label>{{ "utility_account_username" | translation }}</label>
      <input
        autocomplete="new-username"
        [placeholder]="'username' | translation"
        style="max-width: 100%"
        formControlName="username"
        nbInput
        [ngClass]="
          integrationForm?.controls?.username.pristine
            ? ''
            : integrationForm?.controls?.username.valid
            ? 'input-valid'
            : 'input-invalid'
        "
      />
      <div class="wizard-integration-create-form-field-label-error-wrapper">
        <span
          class="wizard-integration-create-form-field-label-error"
          *ngIf="
            integrationForm?.controls?.username?.dirty &&
            integrationForm?.controls?.username?.errors?.required
          "
        >
          <i class="fa-solid fa-triangle-exclamation"></i>

          {{ "required" | translation }}
        </span>
      </div>
    </nb-form-field>

    <nb-form-field autocomplete="new-util-ba">
      <label>{{ "utility_account_password" | translation }}</label>
      <input
        autocomplete="new-utils-ppp"
        [placeholder]="'password' | translation"
        style="max-width: 100%"
        formControlName="password"
        [type]="showHiddenInput ? 'text' : 'password'"
        nbInput
        [ngClass]="
          integrationForm?.controls?.password.pristine
            ? ''
            : integrationForm?.controls?.password.valid
            ? 'input-valid'
            : 'input-invalid'
        "
      />
      <button
        style="background-color: transparent;"
        nbSuffix
        nbButton
        ghost
        status="basic"
        (click)="showHiddenInput = !showHiddenInput"
        type="button"
      >
        <i class="fa-solid fa-eye" *ngIf="showHiddenInput"></i>
        <i class="fa-thin fa-eye" *ngIf="!showHiddenInput"></i>
      </button>
      <div class="wizard-integration-create-form-field-label-error-wrapper">
        <span
          class="wizard-integration-create-form-field-label-error"
          *ngIf="
            integrationForm?.controls?.password?.dirty &&
            integrationForm?.controls?.password?.errors?.required
          "
        >
          <i class="fa-solid fa-triangle-exclamation"></i>

          {{ "required" | translation }}
        </span>
      </div>
    </nb-form-field>
  </div>

  <div class="wizard-integration-create-bottom-row">
    <div class="wizard-integration-create-bottom-row-status">
      <label>{{ "status" | translation }}:</label>
      <label>{{ status|translation }}</label>
    </div>
    <button
      [disabled]="!integrationForm.valid || isProcessing"
      nbButton
      ghost
      class="wizard-integration-create-bottom-row-button text-link-color"
      (click)="createIntegration()"
    >
      <i
        class="fa-solid fa-plus text-link-color"
        style="margin-right: 10px"
      ></i>

      {{ "create_integration" | translation }}
    </button>
  </div>
</ng-container>
